import { Component } from 'react';
import _ from 'lodash';
import { Input } from 'antd';

import React from 'react';

export default class InputBouncy extends Component {
  constructor(props) {
    super(props);
    if (this.props.name) console.log('input bouncy ', this.props.name, 'value:', this.props.value);
    this.state = { value: props.value, changed: false };
  }

  update(event) {
    this.update = _.debounce(
      (event) => {
        if (this.props.onChange) {
          this.props.onChange(event);
        }
      },
      100,
    );
    this.update(event);
  }

  get onChange() {
    return (event) => {
      event.persist();
      this.setState({ changed: true, value: _.get(event, 'target.value', '') }, () => {
        this.update(event);
      });
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.props.value !== this.state.value && (!this.state.changed)) {
      this.setState({ value: this.props.value });
    }
  }

  render() {
    return (<Input
      {...this.props}
      value={this.state.value}
      onChange={this.onChange}
    />);
  }
}
